import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/*
    playback -->      regionIn
                             | 
    clip_1            A | AD | D |
    clip_2                   | A | AD | D  --> 
                                 | 
                                 regionOut
    A - active
    D - damping
*/

export type PlaybackElement = ClipId | ClipId[] | null;

export interface Playback {
  activePlayerIndex: Index;
  dampingPlayerIndex: State['dampingPlayerIndex'];
  linkedGroupIndex: State['linkedGroupIndex'];
  playbackClips: State['playbackClips'];
  isEmptyCell: boolean;
}

export interface State {
  isEmptyCell: boolean;
  activePlayerIndex: Index;
  dampingPlayerIndex: Index | null;
  linkedGroupIndex: Index | null;
  playbackClips: PlaybackElement[];
}

const initialState: State = {
  isEmptyCell: false,
  activePlayerIndex: 0,
  dampingPlayerIndex: null,
  linkedGroupIndex: null,
  playbackClips: [],
};

// S L I C E

export const sbPlayerSlice = createSlice({
  name: 'sb__player',
  initialState,
  reducers: {
    setDampingPlayerIndex: (state, action: PayloadAction<State['dampingPlayerIndex']>) => {
      state.dampingPlayerIndex = action.payload;
    },
    setPlayback: (state, action: PayloadAction<Playback>) => {
      const { activePlayerIndex, dampingPlayerIndex, linkedGroupIndex, playbackClips, isEmptyCell } = action.payload;
      state.activePlayerIndex = activePlayerIndex;
      state.dampingPlayerIndex = dampingPlayerIndex;
      state.linkedGroupIndex = linkedGroupIndex;
      state.playbackClips = playbackClips;
      state.isEmptyCell = isEmptyCell;
    },
    resetSbPlayback: () => {
      return initialState;
    },
  },
});

export const { setDampingPlayerIndex, setPlayback, resetSbPlayback } = sbPlayerSlice.actions;
export default sbPlayerSlice.reducer;
